import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { ISecurityQuestionResource } from '../data/security-question';
let template = require('./security-question.html');

class SecurityQuestionComponent extends ComponentRegistration {

    constructor() {
        super('securityQuestion', {
            controller: SecurityQuestionController,
            templateUrl: template,
            controllerAs: 'security',
            bindings: {
                ngDisabled: "@",
                answer: '=?',
                question: '=?',
                form: "&"
            }
        });
    }
}

interface ISecurityQuestionController {
    loadQuestions(): void;
}

class SecurityQuestionController implements ISecurityQuestionController {
    private static $inject: Array<string> = ['SecurityQuestion'];

    //private fields
    private isBadCredentials: Boolean = false;
    private email: string = '';
    private password: string = '';
    private hostForm: Function = null;
    private questions: Array<any> = [];

    //bindings
    private ngDisabled: any;
    private answer: string;
    private question: string;
    private form: Function;

    constructor(private SecurityQuestion: ISecurityQuestionResource) {

        console.log('SecurityQuestionController loaded');

    }

    public $onInit(): void {
        this.question = this.question || '';
        this.answer = this.answer || '';

        this.hostForm = this.form();
        this.loadQuestions();
        console.log('SecurityQuestionController activated');
    }

    public loadQuestions(): void { 
        this.SecurityQuestion.get().$promise
            .then((response) => {
                this.questions = response;
            })
            .catch((e) => {
                console.log(e);
            });
    }


    public onChangeSecurityQuestionClick(): void {

    }

}

let sqComponent = new SecurityQuestionComponent();
export default sqComponent;
export { sqComponent as SecurityQuestionComponent, ISecurityQuestionController, SecurityQuestionController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/user-controls/security-question.ts